// extracted by mini-css-extract-plugin
export default {"toolbarButton":"toolbarButton__x9ODQU","wandIcon":"wandIcon__wpOvoN"};